import Vue from 'vue'
import Router from 'vue-router'
import Viewer from './views/Viewer.vue'
import Index from './views/Index.vue'
import Login from './components/Login.vue'
import ExamEditor from './components/ExamEditor.vue'
import VrEditor from './components/VrEditor.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Index
    },

    {
      path: '/samyookvr',
      name: 'samyookvr',
      component: () => import('./views/KoreaIndex.vue')
    },

    {
      path: '/viewer/:id',
      name: 'viewer',
      component: Viewer
    },
    {
      path: '/viewer/test/:id',
      name: 'test',
      component: Viewer
    },
    {
      path: '/admin',
      name: 'login',
      component: Login
    },
    {
      path: '/admin/exam/editor/:id?',
      name: 'exam.editor',
      component: ExamEditor,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/vr/editor/:id',
      name: 'vr.editor',
      component: VrEditor
    },
    { path: '*', redirect: { name: 'home' } }
  ]
})
